"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Frontend = /** @class */ (function () {
    function Frontend() {
        var _this = this;
        window.addEventListener('DOMContentLoaded', function () {
            _this.init();
        });
    }
    Frontend.prototype.init = function () {
        var _this = this;
        var _a, _b, _c, _d, _e;
        (_a = document.querySelector('#composer-block')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', this.selectText.bind(this));
        (_b = document.querySelector('form[name="delete_app"]')) === null || _b === void 0 ? void 0 : _b.addEventListener('submit', this.checkName.bind(this));
        (_c = document.querySelector('form[name="app_icon"]')) === null || _c === void 0 ? void 0 : _c.addEventListener('submit', this.uploadIcon.bind(this));
        (_d = document.querySelector('#app_icon_avatar_icon')) === null || _d === void 0 ? void 0 : _d.addEventListener('input', this.autoSubmit.bind(this));
        (_e = document.querySelector('#install-customer-select')) === null || _e === void 0 ? void 0 : _e.addEventListener('change', this.updateComposerInfo.bind(this));
        document.addEventListener('keydown', this.keybind.bind(this));
        this.themeSwitcher = document.querySelectorAll('.theme-switch');
        this.switchTheme();
        this.themeSwitcher.forEach(function (button) { return button.addEventListener('click', function () { return _this.switchTheme(button.dataset.theme); }); });
    };
    Frontend.prototype.keybind = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(event.key === 'c' && event.altKey && event.ctrlKey)) return [3 /*break*/, 2];
                        return [4 /*yield*/, fetch('/clear-cache')];
                    case 1:
                        _a.sent();
                        window.location.reload();
                        _a.label = 2;
                    case 2:
                        if (!(event.key === 'a' && event.altKey && event.ctrlKey)) return [3 /*break*/, 4];
                        return [4 /*yield*/, fetch('/install-assets')];
                    case 3:
                        _a.sent();
                        window.location.reload();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Frontend.prototype.updateComposerInfo = function (event) {
        document.querySelector('#composer-block > #git_token').textContent = event.target.selectedOptions[0].dataset.token;
        document.querySelector('#composer-block > #git_user').textContent = event.target.selectedOptions[0].dataset.user;
    };
    Frontend.prototype.autoSubmit = function (event) {
        event.target.form.dispatchEvent(new CustomEvent('submit'));
    };
    Frontend.prototype.uploadIcon = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var body, response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        body = new FormData(event.target);
                        event.target.reset();
                        return [4 /*yield*/, fetch(event.target.action, {
                                method: 'POST',
                                body: body
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        if (response.status === 200) {
                            window.location.reload();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Frontend.prototype.switchTheme = function (mode) {
        if (mode === void 0) { mode = 'auto'; }
        var userMode = localStorage.getItem('bs-theme');
        var sysMode = window.matchMedia('(prefers-color-scheme: light)').matches;
        var useSystem = mode === 'system' || (!userMode && mode === 'auto');
        var modeChosen = useSystem ? 'system' : mode === 'dark' || mode === 'light' ? mode : userMode;
        if (useSystem) {
            localStorage.removeItem('bs-theme');
        }
        else {
            localStorage.setItem('bs-theme', modeChosen);
        }
        document.documentElement.setAttribute('data-bs-theme', useSystem ? (sysMode ? 'light' : 'dark') : modeChosen);
        if (this.themeSwitcher.length) {
            document.querySelectorAll('.mode-switch .btn').forEach(function (e) { return e.classList.remove('text-body'); });
            document.querySelector("[data-theme=\"".concat(modeChosen, "\"")).classList.add('text-body');
        }
        localStorage.setItem('bs-theme', document.documentElement.getAttribute('data-bs-theme'));
    };
    Frontend.prototype.checkName = function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.target.checkValidity();
        var appName = event.target.dataset.appName;
        var input = event.target.querySelector('#delete_app_app_name');
        if (input.value !== appName) {
            input.setCustomValidity('Bitte gebe den Plugin-Name an um das Plugin zu löschen');
            input.reportValidity();
        }
        else {
            input.setCustomValidity('');
            input.reportValidity();
            event.target.submit();
        }
        event.target.checkValidity();
    };
    Frontend.prototype.selectText = function (event) {
        if ('createTextRange' in document.body) {
            var range = document.body.createTextRange();
            range.moveToElementText(this);
            range.select();
        }
        else if (window.getSelection) {
            var selection = window.getSelection();
            var range = document.createRange();
            range.selectNodeContents(event.target);
            selection.removeAllRanges();
            selection.addRange(range);
        }
        else {
            console.warn("Could not select text in node: Unsupported browser.");
        }
    };
    return Frontend;
}());
exports.default = Frontend;
